import { FlowControl } from './flowControl';
import { DataURIToBlob, blobToBase64, urlToBase64 } from '../utils'
import { Alignment, ImageVerticalAlignment } from 'pdfmake/interfaces';
import { Litter } from './litter';

export class OrganizationMember {
    id: number | null = null;

    userId: number | null = null
    email: string | null = null;
    firstName: string | null = null;
    lastName: string | null = null;
    isActive: boolean = false;
    role: string| null = ''

    isRoleAdmin: boolean = false;
    isRoleWriteAnimals: boolean = false;
    isRoleReadAnimals: boolean = false;
    isRoleWriteAgenda: boolean = false;
    isRoleReadAgenda: boolean = false;
    isRoleWritePlan: boolean = false;
    isRoleReadPlan: boolean = false;

    isRoleWriteMembers: boolean = false;
    isRoleReadMembers: boolean = false;
    isRoleWritePharmacy: boolean = false;
    isRoleReadPharmacy: boolean = false;
    isRoleWriteShare: boolean = false;
    isRoleReadShare: boolean = false;
    isRoleWriteVet: boolean = false;
    isRoleReadVet: boolean = false;
    isRoleWriteOrganization: boolean = false;
    isRoleWriteFosterFamily: boolean = false;
    isRoleReadFosterFamily: boolean = false;
    isBenevoleWalker: boolean = false;

    isRoleWriteLitter: boolean = true;
    isRoleReadLitter: boolean = true;

    isRoleWriteCompta: boolean = false;
    isRoleReadCompta: boolean = false;

    isRoleDiscussionModerator: boolean = false;
    
    isOnlyBenevoleWalker() {
        return !this.isRoleAdmin && !this.isRoleWriteAnimals && !this.isRoleReadAnimals && !this.isRoleWriteAgenda && !this.isRoleReadAgenda && !this.isRoleWritePlan && !this.isRoleReadPlan && !this.isRoleWriteMembers && !this.isRoleReadMembers && !this.isRoleWritePharmacy && !this.isRoleReadPharmacy && !this.isRoleReadShare && !this.isRoleWriteShare && !this.isRoleWriteShare && !this.isRoleWriteVet && !this.isRoleReadVet && !this.isRoleWriteOrganization && !this.isRoleWriteFosterFamily && !this.isRoleReadFosterFamily && !this.isRoleWriteCompta && !this.isRoleReadCompta && !this.isRoleDiscussionModerator && this.isBenevoleWalker
    }
}

export class OrganizationFosterFamily {
    id: number | null = null;
    firstName: string | null = null;
    lastName: string | null = null;
    phoneNumber: string | null = null;
    address: string | null = null;
    email: string | null = null;
}

export class AnimalRefugeCategory {
    id: number | null = null;
    name: string | null = null;
    description: string | null = null;
    color: string | null = null;
}

export class Organization {
    id: number | null = null;
    name: string | null = null;
    affix: string | null = null;
    types: string[] = [];
    isActivePublicPage: boolean = false;
    members: OrganizationMember[] = [];
    refugeCategories: AnimalRefugeCategory[] = [];
    test:string = ''
    fosterFamilies: OrganizationFosterFamily[] = [];
    flowControls: FlowControl[] = [];
    userId: number | null = null;

    publicDescriptionJSON: string | null = null;
    publicDescriptionHTML: string | null = null;

    avatarNewFileName: string | null = null;
    avatar: string = '';
    avatarBase64: string | null = null;

    email: string | null = null;
    phoneNumber: string | null = null;
    addrStreet: string | null = null;
    addrCity: string | null = null;
    addrPostalCode: string | null = null;
    addrCountry: string | null = null;
    
    subscription: OrganizationSubscription | null = null;
    
    postDefaultVisiblity: string = '2';
    postDefaultVisiblityLitter: string = '2';

    litters: Litter[] = [];

    async getPDFHeader() {
        return {
            stack: [
              {
                table: {
                  widths: ['auto', '*'],//, '*'
                  body: [
                    [
                      { image: this.avatarBase64 ? this.avatarBase64:null, fit: [35, 35], alignment: 'left' as Alignment, verticalAlignment: 'middle'  },
                      { text: this.name ?? '', style: 'headerTitle', alignment: 'left' as Alignment,  },
                      //{ image: iconPNG, fit: [35, 35], alignment: 'right' as Alignment, verticalAlignment: 'middle'  },
                    ],
                  ],
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 0] as [number, number, number, number],
              },
            ],
          }
    }
}

export class OrganizationSubscription {
    id: string = '00';
    name: string | null = null;
    description: { description: string }[] = [];
    price: number | null = null;
    priceString: string | null = null;
    currency: string | null = null;
    currencySymbol: string | null = null;
    isActive: boolean = false;
    limitations: {
        nbDogsPerSpecies: number | null;
        nbLittersTotal: number | null;
        nbLittersPerYear: number | null;
    } | null = null;
    descriptions: { description: string }[] = [];
}

export class OrganizationSubscriptionTransaction {
    id: number | null = null;
    userId: number | null = null;
    subscription: string | null = null;
    transactionId: string | null = null;
    transactionSource: string | null = null;
    receipt: string | null = null;
}
